const DEV_HOWIE_API_URL = 'http://localhost:8080';
const PRODUCTION_HOWIE_API_URL = 'https://howie-sdk-service-production.up.railway.app';

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function apiUrlToWsBaseUrl(apiUrl: string): string {
  return stripTrailingSlash(apiUrl).replace(/^https:/, 'wss:').replace(/^http:/, 'ws:');
}

export function getHowieApiUrl(): string {
  return stripTrailingSlash(
    import.meta.env.VITE_HOWIE_API_URL ||
      (import.meta.env.DEV ? DEV_HOWIE_API_URL : PRODUCTION_HOWIE_API_URL),
  );
}

export function getHowieWsBaseUrl(): string {
  const explicitWsUrl = import.meta.env.VITE_HOWIE_WS_URL;
  const baseUrl = explicitWsUrl || apiUrlToWsBaseUrl(getHowieApiUrl());
  return stripTrailingSlash(baseUrl.replace(/\/ws\/howie\/?$/, ''));
}

export function getHowieWsUrl(): string {
  return `${getHowieWsBaseUrl()}/ws/howie`;
}
